<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   [searchText]="searchText"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
>
   <ndt-register-quick-filter>
      <mat-form-field>
         <mat-label>Filter by Account</mat-label>
         <input
            autocomplete="off"
            type="text"
            [lcsSingleSelect]="accountSel"
            ndtAccountSelect
            [value]="selectedAccount?.name"
            [ngModel]="selectedAccount"
            (ngModelChange)="onAccountSelected($event)"
            id="user-account"
         />
         <ndt-account-select #accountSel isIncludeEmptyOption="true"></ndt-account-select>
      </mat-form-field>
      @if (isSystemUser) {
      <mat-form-field>
         <mat-label>Provider</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [(ngModel)]="selectedProvider"
            id="providerId"
            lcsStaticSelect
            [lcsSingleSelect]="providerSelect"
            [lcsStaticSelectValue]="null"
            (search)="providerSearch($event)"
            (reset)="providerReset()"
            (ngModelChange)="providerFilterChange($event)"
         />
         <lcs-static-select
            #providerSelect
            [displayWith]="providerDisplayWith"
            [autoActiveFirstOption]="false"
            [isIncludeEmptyOption]="true"
         >
            <lcs-option [value]="null">{{ '' }}</lcs-option>
            @for (provider of providers; track provider) {
            <lcs-option [value]="provider">
               {{ provider }}
            </lcs-option>
            }
         </lcs-static-select>
      </mat-form-field>
      }
      <mat-slide-toggle
         class="slide-toggle"
         color="primary"
         [ngModel]="isAutoRefresh"
         (ngModelChange)="autoRefreshToggleClicked($event)"
      >
         Auto Refresh
      </mat-slide-toggle>
      <!-- <mat-form-field>
        <mat-label>Filter by Server</mat-label>
        <input
          autocomplete="off"
          type="text"
          [lcsSingleSelect]="serverSel"
          ndtServerSelect
          [ngModel]="selectedServer"
          (ngModelChange)="onServerSelected($event)"
          id="user-server"
          />
          <ndt-server-select #serverSel isIncludeEmptyOption="true"></ndt-server-select>
        </mat-form-field> -->
   </ndt-register-quick-filter>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="accountName" width="4">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="account-name-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'account.name')"
               sortField="account.name"
               >Account<mat-icon class="mat-icon-sort">{{ getSort('account.name') }}</mat-icon></th
            >
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{ activeCalls.accountName }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callDirection" width="2.75">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="call-direction-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'callDirectionTypeId')"
               sortField="callDirectionTypeId"
               >Call Direction<mat-icon class="mat-icon-sort">{{ getSort('callDirectionTypeId') }}</mat-icon></th
            >
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{ activeCalls.callDirection | addSpaces }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callSource" width="4.5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="from-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'sourceNumber')"
               sortField="sourceNumber"
               >From<mat-icon class="mat-icon-sort">{{ getSort('sourceNumber') }}</mat-icon></th
            >
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{ activeCalls.callSource | formatPhoneNumbers }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callDestination" width="4.5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="to-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'destinationNumber')"
               sortField="destinationNumber"
               >To<mat-icon class="mat-icon-sort">{{ getSort('destinationNumber') }}</mat-icon></th
            >
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{ activeCalls.callDestination | formatPhoneNumbers }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callCost" width="3">
            <th class="header-align-right" lcs-header-cell *lcsHeaderCellDef id="call-cost-column-header">Call Cost</th>
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a class="text-align-right" (click)="onOpenDialog(activeCalls)">
                  {{ activeCalls.startTime | callCost : activeCalls?.callRate : currentTime }}
               </a>
            </td>
         </ng-container>
         @if (isSystemUser) {
         <ng-container lcsColumnDef="sourceProvider" width="2.75">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="source-provider-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'sourceProviderId')"
               sortField="sourceProviderId"
               >Source Provider<mat-icon class="mat-icon-sort">{{ getSort('sourceProviderId') }}</mat-icon></th
            >
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{ formatProvider(activeCalls.sourceProviderId) }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="destinationProvider" width="2.5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="destination-provider-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'destinationProviderId')"
               sortField="destinationProviderId"
               >Dest. Provider <mat-icon class="mat-icon-sort">{{ getSort('destinationProviderId') }}</mat-icon></th
            >
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{ formatProvider(activeCalls.destinationProviderId) }}
               </a>
            </td>
         </ng-container>
         }
         <ng-container lcsColumnDef="callDuration" width="2.5">
            <th
               class="header-align-right"
               lcs-header-cell
               *lcsHeaderCellDef
               id="duration-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Asc"
               sortField="startTime"
               >Duration<mat-icon class="mat-icon-sort">{{ getSort('startTime') }}</mat-icon></th
            >
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a class="text-align-right" (click)="onOpenDialog(activeCalls)">
                  {{ activeCalls.startTime | activeDuration }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="activeCallsActionsMenu" width="1">
            <th lcs-header-cell *lcsHeaderCellDef id="call-history-actions-menu-column-header"></th>
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <button
                  type="button"
                  class="duration-button"
                  matTooltip="More Actions"
                  mat-icon-button
                  aria-label="Details Info"
                  id="extension-detail-info"
                  [matMenuTriggerFor]="activeCallsMenu"
               >
                  <mat-icon>more_horiz</mat-icon>
               </button>
               <mat-menu #activeCallsMenu="matMenu">
                  <button mat-menu-item type="button" id="active-call-details" (click)="onOpenDialog(activeCalls)">
                     Details
                  </button>
                  @if (hangupActiveCallsPrivileges.enabled) {
                  <button mat-menu-item type="button" id="active-call-hangup" (click)="onHangupActiveCall(activeCalls)">
                     Hangup
                  </button>
                  }
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
